// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIhIuyo0XOWPxCN2ifcSBM5ejBHu-qwd4",
  authDomain: "hub971run.firebaseapp.com",
  projectId: "hub971run",
  storageBucket: "hub971run.firebasestorage.app",
  messagingSenderId: "919994257818",
  appId: "1:919994257818:web:9e3b571018147f0ad96a23",
  measurementId: "G-7PDXJT21GY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;

